export class PromozioneRequest {
    classePrecedenteId?: string;
    // materieId?: Array<string>;
    studentiId?: Array<string>;
}